import type { Affiliate, Offer, OfferCategory } from 'models/offer';

import type { ICountry } from './reducer';

export enum OffersActionTypes {
  GET_OFFERS_REQUEST = 'GET_OFFERS_REQUEST',
  SET_CURRENT_OFFER = 'SET_CURRENT_OFFER',
  UPDATE_CURRENT_OFFER = 'UPDATE_CURRENT_OFFER',
  SET_CURRENT_CATEGORIES = 'SET_CURRENT_CATEGORIES',
  SET_CURRENT_AFFILIATES = 'SET_CURRENT_AFFILIATES',
  UPDATE_CURRENT_COUNTRY = 'UPDATE_CURRENT_COUNTRY',
  SET_CURRENT_COUNTRIES = 'SET_CURRENT_COUNTRIES',
  UPDATE_CURRENT_COUNTRY_WARRANTY = 'UPDATE_CURRENT_COUNTRY_WARRANTY',
}

interface IGetOffersRequestAction {
  type: OffersActionTypes.GET_OFFERS_REQUEST;
  payload: Offer[] | undefined;
}

interface ISetCurrentOfferAction {
  type: OffersActionTypes.SET_CURRENT_OFFER;
  payload: number;
}

interface IUpdateCurrentOfferAction {
  type: OffersActionTypes.UPDATE_CURRENT_OFFER;
  payload: Offer;
}
interface ISetCurrentCategoriesAction {
  type: OffersActionTypes.SET_CURRENT_CATEGORIES;
  payload: OfferCategory[] | undefined;
}
interface ISetCurrentAffiliatesAction {
  type: OffersActionTypes.SET_CURRENT_AFFILIATES;
  payload: Affiliate[] | undefined;
}

interface IUpdateCurrentCountryAction {
  type: OffersActionTypes.UPDATE_CURRENT_COUNTRY;
  payload: ICountry;
}

interface ISetCurrentCountriesAction {
  type: OffersActionTypes.SET_CURRENT_COUNTRIES;
  payload: ICountry[];
}
interface IUpdateCurrentCountryWarrrantyAction {
  type: OffersActionTypes.UPDATE_CURRENT_COUNTRY_WARRANTY;
  payload: { id: number; warranty: number };
}

export type TOffersActions =
  | IGetOffersRequestAction
  | ISetCurrentOfferAction
  | IUpdateCurrentOfferAction
  | ISetCurrentCategoriesAction
  | ISetCurrentAffiliatesAction
  | IUpdateCurrentCountryAction
  | ISetCurrentCountriesAction
  | IUpdateCurrentCountryWarrrantyAction;

export const setOffers = (payload: Offer[] | undefined): TOffersActions => ({
  type: OffersActionTypes.GET_OFFERS_REQUEST,
  payload,
});

export const setCurrentOfferAction = (payload: number): TOffersActions => ({
  type: OffersActionTypes.SET_CURRENT_OFFER,
  payload,
});

export const updateCurrentOfferAction = (payload: Offer): TOffersActions => ({
  type: OffersActionTypes.UPDATE_CURRENT_OFFER,
  payload,
});

export const setCurrentCategoriesAction = (payload: OfferCategory[] | undefined): TOffersActions => ({
  type: OffersActionTypes.SET_CURRENT_CATEGORIES,
  payload,
});

export const setCurrentAffiliatesAction = (payload: Affiliate[] | undefined): TOffersActions => ({
  type: OffersActionTypes.SET_CURRENT_AFFILIATES,
  payload,
});

export const updateCurrentCountryAction = (payload: ICountry): TOffersActions => ({
  type: OffersActionTypes.UPDATE_CURRENT_COUNTRY,
  payload,
});

export const setCurrentCountriesAction = (payload: ICountry[]): TOffersActions => ({
  type: OffersActionTypes.SET_CURRENT_COUNTRIES,
  payload,
});

export const updateCurrentCountryWarrantyAction = (payload: {
  id: number;
  warranty: number;
}): TOffersActions => ({
  type: OffersActionTypes.UPDATE_CURRENT_COUNTRY_WARRANTY,
  payload,
});
